var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-block-list-accordion",attrs:{"id":("block-" + (_vm.$vnode.key))}},[(_vm.title && _vm.showTitleInToc)?_c('LongReadTarget',{staticClass:"relative z-10",staticStyle:{"top":"2em"},attrs:{"container-id":("block-" + (_vm.$vnode.key)),"link-to-toc":{
			name: ("Spring til \"" + _vm.title + "\" i indholdsfortegnelsen"),
			attrs: {
				'data-focus-ignore': true,
			},
		},"title":_vm.title}}):_vm._e(),_vm._v(" "),_c('AccordionLayout',{attrs:{"title":_vm.title,"elements":_vm.elements},scopedSlots:_vm._u([{key:"panel",fn:function(ref){
		var item = ref.item;
return [_c('BlockList',{attrs:{"block-list":item.content.accordionElements}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }